import React from "react";

export default function Section23() {
  return (
    <div className="w-full Section3 px-5 md:px-0 pt-[2%]">
      <div className="flex flex-col items-center w-full md:flex-row justify-evenly section3-container">
        <div className="w-full md:w-[36%] text-[#373737]">
          <h2 className="text-[26px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#DA2128] my-[0.67em] pb-[2%]">
            Professional New York Web Design Agency
          </h2>
          <p className="leading-[20px] pb-[1%] text-base mb-5">
            Mean3 delivers complete web development solutions for businesses looking to grow and engage their audience effectively. Our team builds websites that are secure, scalable, and fully responsive, ensuring optimal performance across all devices. With a focus on quality web design services in New York, we handle every stage of development—from custom website design and backend architecture to platform migration and third-party integrations—following the standards of top website development agencies. Whether launching a new site or upgrading an existing one, we create tailored solutions that enhance usability, speed, and overall user experience. By combining technical expertise with thoughtful design, we deliver reliable, high-performing websites aligned with your business goals.
          </p>
          
        </div>

        <div className="w-full md:w-auto">
          <img
            src="../../../assets/computer-shopify.png"
            alt="Computer Logo"
            className="w-full md:w-auto cover"
          />
        </div>
      </div>
      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
